import { EmploymentType } from "@nimble/data-service-client/types";

/**
 * Formats employment type string into a readable format
 * @param type - The employment type to format (can be undefined or any string)
 * @returns Formatted employment type with proper capitalization and dashes, defaults to "Full-time"
 *
 * @example
 * formatEmploymentType("full_time") // "Full-time"
 * formatEmploymentType("part_time") // "Part-time"
 * formatEmploymentType(undefined) // "Full-time"
 * formatEmploymentType("contract") // "Contract"
 */
export function formatEmploymentType(type: string | null | undefined): string {
  if (!type) return "Full-time";
  return type.charAt(0).toUpperCase() + type.slice(1).replace(/_/g, "-");
}

/**
 * Type guard to check if a string is a valid EmploymentType
 * @param type - The string to check
 * @returns True if the string is a valid EmploymentType
 */
export function isValidEmploymentType(type: string): type is EmploymentType {
  return type === "full_time" || type === "part_time";
}

/**
 * Safely converts a string to EmploymentType, falling back to "full_time"
 * @param type - The string to convert
 * @returns A valid EmploymentType
 */
export function toEmploymentType(
  type: string | null | undefined,
): EmploymentType {
  if (!type || !isValidEmploymentType(type)) {
    return "full_time";
  }
  return type;
}
